import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

const MARGIN_DEFAULT: number = 5
const TEXT_SIZE_DEFAULT: number = 30
const INDICATOR_POS_DEFAULT: number = 35
const SHOW_CUE_DETAILS: boolean = true
const SHOW_OVERSCROLL_BLACKOUT_DEFAULT: boolean = true
const TEXT_IS_UPPERCASE_DEFAULT: boolean = false
const INVERT_COLORS_DEFAULT: boolean = false
const AUTO_SCROLL_TO_ACTIVE_CUE: boolean = false
const TEXT_ALIGN_DEFAULT: string = 'start'

export const storedMarginSizeAtom = atomWithStorage<number>(
  'storedMarginSize',
  MARGIN_DEFAULT,
)
export const storedTextSizeAtom = atomWithStorage<number>(
  'storedTextSize',
  TEXT_SIZE_DEFAULT,
)
export const storedIndicatorPosAtom = atomWithStorage<number>(
  'storedIndicatorPos',
  INDICATOR_POS_DEFAULT,
)
export const storedSpeedAtom = atomWithStorage<number>('storedSpeed', 2)
export const storedShowCueDetailsAtom = atomWithStorage<boolean>(
  'storedShowCueDetails',
  SHOW_CUE_DETAILS,
)
export const storedShowOverscrollBlackoutAtom = atomWithStorage<boolean>(
  'storedShowOverscrollBlackout',
  SHOW_OVERSCROLL_BLACKOUT_DEFAULT,
)
export const storedTextIsUppercaseAtom = atomWithStorage<boolean>(
  'storedTextIsUppercase',
  TEXT_IS_UPPERCASE_DEFAULT,
)
export const storedInvertColorsAtom = atomWithStorage<boolean>(
  'storedInvertColors',
  INVERT_COLORS_DEFAULT,
)
export const storedAutoScrollToActiveCueAtom = atomWithStorage<boolean>(
  'storedAutoScrollToActiveCueAtom',
  AUTO_SCROLL_TO_ACTIVE_CUE,
)
export const storedTextAlignAtom = atomWithStorage<string>(
  'storedTextAlign',
  TEXT_ALIGN_DEFAULT,
)
export const isScrollingAtom = atom<boolean>(false)
export const syncChangesAtom = atom<boolean>(false)
